// Item view for a workspace, intended to be used by the show_development_devicegroups controller

import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/collaborators-profile.hbs';
import async from 'async';
var globalCh = Radio.channel('global');

var CollaboratorsProfileView = Marionette.View.extend({
    template: Handlebars.compile(template),
    tagName: 'div',
    className: 'standard-layout',
    ui: {
        username: '.username',
        email: '.email',
        change_email: '.change_email',
        password: '.password',
        change_password: '.change_password',
        roles: '.roles',
        rolesHelp: '.roles-help',
        form: 'form',
        roleCheckboxes: 'input[name="role"]',
        submitBtn: 'button[type="submit"]',
        created_at: '.created_at'
    },
    events: {
        'change @ui.roleCheckboxes': 'onRoleSelectionChange',
        'submit form': 'onSubmit'
    },
    modelEvents: {
        'change': 'render'
    },
    templateContext: function () {
        var active = globalCh.request('active_account');
        var account_name = active.get('username');
        var is_self = active === this.model;
        let api_roles = this.getOption('available_roles').models;
        // Add roles that have been granted, but AREN'T available anymore, because
        // insanity
        api_roles = _.uniq(api_roles.concat(this.getOption('granted_roles')));
        // Find which roles have been granted to this account
        api_roles = _.map(this.getOption('available_roles').models, function(model) {
            return model.toJSON();
        });
        // Mark the roles that have been granted
        _.each(api_roles, function(role) {
            if (_.contains(_.pluck(this.getOption('granted_roles'), 'id'), role.id)) {
                role.granted = true;
            }
        }, this);

        api_roles = _.sortBy(api_roles, function(item){ return item.name; });
        
        return {
            roles: api_roles,
            is_self: is_self,
            account_name: account_name,
            created_at: this.getOption('created_at')
        };
    },
    render_created_at: function(created_at){
        var created_at_view = new Marionette.View({
            tagName: 'span',
            template: Handlebars.compile('{{#date_UTC}}{{created_at}}{{/date_UTC}}'),
            templateContext: function() {
                return { created_at: created_at };
            }
        });
        this.showChildView('created_at_region', created_at_view);
    },
    // Roles methods, absconded from collaborator_detail.js
    onRoleSelectionChange: function(e) {
        this.updateButtonState();
    },
    // Only enable the update button if the user has made changes
    updateButtonState: function() {
        var selectedRoles = this.getSelectedRoles();

        var rolesToAdd = this.getRolesToAdd(selectedRoles);
        var rolesToRemove = this.getRolesToRemove(selectedRoles);

        if (selectedRoles.length && (rolesToAdd.length || rolesToRemove.length)) {
            this.ui.submitBtn.prop('disabled', false);
        } else {
            this.ui.submitBtn.prop('disabled', true);
        }
    },

    getSelectedRoles: function() {
        var fields = this.ui.form.serializeArray();

        var selectedRoles = _.chain(fields)
            .filter(function(field) {
                return field.name === 'role';
            })
            .map(function(roleField) {
                return this.getOption('available_roles').get(roleField.value);
            }, this)
            .compact()
            .value();

        return selectedRoles;
    },
    getRolesToAdd: function(selectedRoles) {
        var rolesToAdd = _(selectedRoles).filter(function(role) {
            return _(this.getOption('granted_roles')).contains(role) === false;
        }, this);

        return rolesToAdd;
    },
    getRolesToRemove: function(selectedRoles) {
        var rolesToRemove = _(this.getOption('granted_roles')).filter(function(role) {
            return _(selectedRoles).contains(role) === false;
        });
        return rolesToRemove;
    },
    onSubmit: function(event) {
        event.preventDefault();

        // Disable submit button
        this.ui.submitBtn.prop('disabled', true);

        var selectedRoles = this.getSelectedRoles();

        var rolesToAdd = this.getRolesToAdd(selectedRoles);
        var rolesToRemove = this.getRolesToRemove(selectedRoles);

        var grantsToDestroy = [];
        rolesToRemove.forEach(function(role) {
            var grants = this.getOption('account').grants().filter(function(grant) {
                return grant.rel.get('grantee') === this.model 
                    && grant.rel.get('role') === role;
            }, this);
            grantsToDestroy = grantsToDestroy.concat(grants);
        }, this);

        // Actually add and remove the appropriate roles,
        // returning the user to the collaborator list on success
        // (Add roles *first* because if we delete we may lose collaborator status)
        async.series([
            _.bind(function(done) {
                async.each(rolesToAdd, _.bind(function(role, cb) {
                    this.getOption('account').grant(this.model, role, {
                        success: function() {
                            cb();
                            Radio.request('alerts', 'showAlert', {
                                message: 'Roles updated',
                                messageType: 'success'
                            });
                        },
                        error: function(model, response) {
                            cb(response);
                        }
                    });
                }, this), done);
            }, this),
            _.bind(function(done) {
                async.each(grantsToDestroy, _.bind(function(grant, cb) {
                    grant.destroy({
                        success: function() {
                            cb();
                            Radio.request('alerts', 'showAlert', {
                                message: 'Roles updated',
                                messageType: 'success'
                            });
                        },
                        error: function(model, response) {
                            cb(response);
                        }
                    });
                }, this), done);
            }, this)
        ], function(err) {
            if (err) {
                Radio.request('alerts', 'showAlert', {
                    message: 'Adding or removing one or more roles failed',
                    messageType: 'danger'
                });
            }
        });
    }

});

export default CollaboratorsProfileView;
